<app-button (onClick)="login()" [type]="eButtonType.MICROSOFT" [buttonWidth]="'100%'">
    <span class="fab fa-windows"></span>
    <span class="m-left-5">Sign in with Microsoft</span>
</app-button>